import { IUserDetails } from "repoV2/features/Common/modules/FormData/interfaces/UserDetailsFormGroup.interfaces";
import getCountryCodeOptionsList from "repoV2/features/CheckoutPages/utils/getCountryCodeOptionsList";
import { IGSTDetails } from "repoV2/features/Common/modules/FormData/interfaces/GSTDetailsFormGroup.interfaces";
import { IDeliveryDetails } from "repoV2/features/Common/modules/FormData/interfaces/IDeliveryDetails.interface";
import { INDIA_COUNTRY_DATA } from "repoV2/utils/common/location/countriesData";
import {
    getCountryDataBasedOnTimezone,
    getUserTimezone,
} from "repoV2/features/Common/modules/Timezone/Timezone.utils";
import { FORM_KEYS } from "repoV2/features/Common/modules/FormData/FormData.constants";
import { checkIsArrayEmpty } from "repoV2/utils/common/dataTypes/array";
import { booking_customer_type } from "../Payments.constants";
import { IGeneratePaymentPayload } from "../Payments.interface";

export const generateCustomerDetails = ({
    userDetails = {},
    gstDetails = {},
    deliveryDetails = {},
    addressDetailsPayloadHelper = {},
    firstUserId,
}: {
    userDetails: { [userId: string]: IUserDetails };
    deliveryDetails: IDeliveryDetails;
    gstDetails: IGSTDetails;
    addressDetailsPayloadHelper?: IGeneratePaymentPayload["addressDetailsPayloadHelper"];
    firstUserId: string;
}) => {
    const { countries_flag_data } = getCountryCodeOptionsList();

    const timezone = getUserTimezone();
    const { dial_code: defaultDialCode = INDIA_COUNTRY_DATA.dial_code } =
        getCountryDataBasedOnTimezone({ timezone }) || {};

    return Object.keys(userDetails).map((id: string) => {
        const currentUserDetails = userDetails[id] || {};
        const internationalDetails =
            currentUserDetails[FORM_KEYS.international_details] || {};
        const transactionAnswers =
            currentUserDetails[FORM_KEYS.booking_custom_question_answers] || [];

        const {
            isSendAddressDetails = false,
            showAddressInsideUserDetails:
                sendValuesFromInternationalDetails = false,
        } = addressDetailsPayloadHelper;

        return {
            full_name: currentUserDetails.name,
            email: currentUserDetails.email,
            phone: currentUserDetails.phone,
            country:
                countries_flag_data[
                    currentUserDetails.country_code || defaultDialCode
                ].countryName,
            country_code: currentUserDetails.country_code || defaultDialCode,
            // Send billing state only if it is present
            ...(currentUserDetails.billing_state?.value && {
                billing_state: currentUserDetails.billing_state.value,
            }),
            user_type:
                // see definition of `booking_customer_type`
                id === firstUserId
                    ? booking_customer_type.initial_user
                    : booking_customer_type.multiple_user,
            // Send GST info only if user filled the form
            ...(gstDetails.active && {
                gst_info: {
                    gst_number: gstDetails.registration_number,
                    gst_name: gstDetails.company_name,
                    gst_company_address: gstDetails.company_address,
                    pincode: gstDetails.company_pincode,
                },
            }),
            // Send address details only if the user filled the details which are asked
            // in case of stripe payment gateway flow
            ...(isSendAddressDetails && {
                address_details: {
                    address: sendValuesFromInternationalDetails
                        ? internationalDetails.street_address
                        : deliveryDetails.delivery_address,
                    city: sendValuesFromInternationalDetails
                        ? internationalDetails.town_city
                        : deliveryDetails.delivery_city,
                    postal_code: sendValuesFromInternationalDetails
                        ? internationalDetails.postal_code
                        : deliveryDetails.delivery_pin_code,
                    state: sendValuesFromInternationalDetails
                        ? internationalDetails.user_state
                        : deliveryDetails.delivery_state?.value,
                },
            }),
            // transaction answers: custom question (pre booking) answers, only if present
            ...(!checkIsArrayEmpty(transactionAnswers) && {
                transaction_answers: transactionAnswers,
            }),
        };
    });
};
